import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import { useShowModal } from '@Elements/Modal/ModalHooks';

import dLibraLogo from '@Assets/images/dLibra.svg';

const TranscriptionDetailsDLibraStatus = ({ transcriptionId, viewMode, status, isPublic }) => {
	const { t } = useTranslation();

	const isLoggedIn = useSelector(state => state.auth.credentials.isLoggedIn);

	const modalSendToDLibra = useShowModal({
		title: t('modals.sendToDLibra.title'),
		name: "sendToDLibra",
		componentPath: "./parts/ModalSendToDLibra",
		componentProps: { transcriptionId: parseInt(transcriptionId) },
	});

	return (
		<div>
			{(isLoggedIn) && status && status !== "undefined" &&
				<div>
					<p style={{ marginBottom: "10px" }}>
						<img src={dLibraLogo} />
						<span style={{ marginLeft: "10px" }}>{t("transcription.details.dLibra.importedFromDLibra")}</span>
					</p>
					<p> {t("transcription.details.dLibra.status")}:
						<span style={{ marginLeft: "10px", marginRight: "10px" }}>
							{
								status === "new" ? t("transcription.details.dLibra.projentNotSent") :
								status === "ready" ? t("transcription.details.dLibra.projectBeingVerified") :
								status === "rejected" ? <span style={{ color: "#AC4848" }}>{t("transcription.details.dLibra.projectRejected")}</span> :
								status === "accepted" ? <span style={{ color: "#0A585D" }}>{t("transcription.details.dLibra.projectAccepted")}</span> :
								status === "sent" ? <span style={{color: "#0A585D"}}><i className='icon-accept'/>{t("transcription.details.dLibra.projectAccepted")}</span> :
								status === "error" ? <span style={{color: "#AC4848"}}>{t("transcription.details.dLibra.projectError")}</span> : ""
							}
						</span>
						{viewMode === "admin" &&
						<>
							{status === "new" ? (
								<>
									<a href='#' disabled={!isPublic} style={isPublic ? {} : { color: "#606060" }} onClick={modalSendToDLibra}>{t("transcription.details.dLibra.sendProject")}</a>
									<i
										className='transcription__tooltip'
										data-tooltip-id='custom-tooltip' data-tooltip-content={t("transcription.details.dLibra.sendProjectTooltip")}
										data-place='right'
									>
										<i className='icon-question' />
									</i>
								</>) :
							status === "rejected" ? (
								<>
									<i
										className='transcription__tooltip'
										data-tooltip-id='custom-tooltip' data-tooltip-content={t("transcription.details.dLibra.sendProjectRejectedTooltip")}
										data-place='right'
									>
										<i className='icon-question' />
									</i>
									<a href='#' disabled={!isPublic} style={isPublic ? { marginLeft: "10px" } : { marginLeft: "10px", color: "#606060" }} onClick={modalSendToDLibra}>{t("transcription.details.dLibra.sendProjectAgain")}</a>
								</>) :
							status === "error" ? (
								<>
									<a href='#' disabled={!isPublic} style={isPublic ? {marginLeft: "10px"} : {marginLeft: "10px", color: "#606060"}} onClick={modalSendToDLibra}>{t("transcription.details.dLibra.sendProjectAgain")}</a>
								</>) : ""}
						</>}
					</p>
				</div>}
		</div>
	);
};

TranscriptionDetailsDLibraStatus.propTypes = {
	transcriptionId: PropTypes.number,
	viewMode: PropTypes.string,
	status: PropTypes.string,
	isPublic: PropTypes.bool,
};

export default TranscriptionDetailsDLibraStatus;
